import React, { useState } from 'react';
import { apiService } from '../../services/api';
import { useMutation } from '../../hooks/useApi';
import logger from '../../utils/logger';
import { useSettings } from '../../context/SettingsContext';
import { Eye, FileDown } from 'lucide-react';

function RaportMarzhProdukt() {
  const { getCurrencyCode } = useSettings();
  const currencyCode = getCurrencyCode();
  const [from, setFrom] = useState('');
  const [to, setTo] = useState('');
  const [data, setData] = useState([]);
  const [error, setError] = useState('');

  const { mutate: fetchRaport, loading: loadingRaport } = useMutation(
    async ({ from, to }) => {
      return await apiService.get('/raport-marzh-produkt', { params: { from, to } });
    },
    {
      onSuccess: (data) => {
        setData(Array.isArray(data) ? data : (data?.data || []));
        setError('');
      },
      onError: () => {
        setError('Nuk mund te merret raporti.');
      },
      showNotifications: false
    }
  );

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    fetchRaport({ from, to });
  };

  const handleExportPdf = async () => {
    if (!from || !to) {
      setError('Zgjidhni datat per PDF.');
      return;
    }
    try {
      const response = await apiService.get('/raport-marzh-produkt/pdf', {
        params: { from, to },
        responseType: 'blob'
      });
      const file = new Blob([response], { type: 'application/pdf' });
      window.open(URL.createObjectURL(file));
    } catch (err) {
      logger.error('PDF export error:', err);
      setError('Deshtoi shkarkimi i PDF-it.');
    }
  };

  return (
    <div className="space-y-6 animate-fade-in">
      <h2 className="text-3xl md:text-4xl font-bold mb-8 text-gradient-logo flex items-center gap-3 animate-slide-down">
        <div className="p-2 bg-primary-100 dark:bg-primary-900/30 rounded-lg">
          📈
        </div>
        Raport Marzh Produkt
      </h2>

      <form onSubmit={handleSubmit} className="card-premium p-6 grid grid-cols-1 md:grid-cols-3 gap-4">
        <div>
          <label className="form-label">Nga data</label>
          <input type="date" value={from} onChange={(e) => setFrom(e.target.value)} className="input-premium" required />
        </div>
        <div>
          <label className="form-label">Deri me</label>
          <input type="date" value={to} onChange={(e) => setTo(e.target.value)} className="input-premium" required />
        </div>
        <button type="submit" className="btn-primary mt-auto">
          <Eye size={18} /> Shfaq
        </button>
      </form>

      {error && <p className="form-error text-center">{error}</p>}

      {loadingRaport && (
        <div className="flex justify-center items-center py-8">
          <div className="animate-spin rounded-full h-12 w-12 border-4 border-primary-500 border-t-transparent"></div>
        </div>
      )}

      {data.length > 0 && (
        <div className="space-y-4">
          <button onClick={handleExportPdf} className="btn-primary">
            <FileDown size={18} /> Shkarko PDF
          </button>
          <div className="overflow-x-auto rounded-xl border border-gray-200 dark:border-dark-700 shadow">
            <table className="table-premium">
              <thead>
                <tr>
                  <th className="p-3 text-left">Produkti</th>
                  <th className="p-3 text-left">Kategoria</th>
                  <th className="p-3 text-right">Sasia</th>
                  <th className="p-3 text-right">Shitje</th>
                  <th className="p-3 text-right">Blerje</th>
                  <th className="p-3 text-right">Fitim</th>
                  <th className="p-3 text-right">Marzh %</th>
                </tr>
              </thead>
              <tbody>
                {data.map((r, i) => (
                  <tr key={i} className="border-t border-gray-200 dark:border-dark-700 hover:bg-gray-50 dark:hover:bg-dark-700/50">
                    <td className="p-3 font-medium text-gray-700 dark:text-gray-300">{r.produkti}</td>
                    <td className="p-3 text-gray-700 dark:text-gray-300">{r.kategoria}</td>
                    <td className="p-3 text-right font-semibold text-primary-600 dark:text-primary-400">{r.sasia}</td>
                    <td className="p-3 text-right text-gray-700 dark:text-gray-300">{Number(r.shitje).toFixed(2)} {currencyCode}</td>
                    <td className="p-3 text-right text-gray-700 dark:text-gray-300">{Number(r.blerje).toFixed(2)} {currencyCode}</td>
                    <td className="p-3 text-right font-semibold text-green-600 dark:text-green-400">{Number(r.fitim).toFixed(2)} {currencyCode}</td>
                    <td className="p-3 text-right font-semibold text-primary-600 dark:text-primary-400">{Number(r.marzh).toFixed(2)}%</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {!loadingRaport && data.length === 0 && !error && (
        <div className="empty-state">
          <p className="empty-state-title">Asnjë e dhënë për t'u shfaqur</p>
          <p className="empty-state-description">Zgjidhni datat dhe klikoni "Shfaq" për të parë raportin.</p>
        </div>
      )}
    </div>
  );
}

export default RaportMarzhProdukt;
